
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LabourPriceListDetailsDialog extends Serenity.EntityDialog<LabourPriceListDetailsRow, any> {
        protected getFormKey() { return LabourPriceListDetailsForm.formKey; }
        protected getIdProperty() { return LabourPriceListDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return LabourPriceListDetailsRow.localTextPrefix; }
        protected getService() { return LabourPriceListDetailsService.baseUrl; }
        protected getDeletePermission() { return LabourPriceListDetailsRow.deletePermission; }
        protected getInsertPermission() { return LabourPriceListDetailsRow.insertPermission; }
        protected getUpdatePermission() { return LabourPriceListDetailsRow.updatePermission; }

        protected form = new LabourPriceListDetailsForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.PurStdRate);
            q.setTextRightAlign(this.form.SaleStdRate);
            q.setTextRightAlign(this.form.FromWt);
            q.setTextRightAlign(this.form.ToWt);
        }

    }
}